module.exports = vendors_ru_f843a3a5a6152f55aa6e;